"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getEventTrackingConfig;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));
var _contentful = require("contentful");
var _defaultEventTrackingConfig = _interopRequireDefault(require("./defaultEventTrackingConfig"));
// TODO:
// fetch from archer
var contentfulClient = (0, _contentful.createClient)({
  // This is the space ID. A space is like a project folder in Contentful terms
  space: 'vko4isvle8g4',
  // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
  accessToken: 'uKvvFkkSd-Sl-zFMd4rTLj8eT1maZENWmuYDovGkt7E'
});
var config = null;
function getEventTrackingConfig(_x) {
  return _getEventTrackingConfig.apply(this, arguments);
}
function _getEventTrackingConfig() {
  _getEventTrackingConfig = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(useLocalConfig) {
    var entry;
    return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (config) {
            _context.next = 9;
            break;
          }
          if (!useLocalConfig) {
            _context.next = 5;
            break;
          }
          config = _defaultEventTrackingConfig["default"];
          _context.next = 9;
          break;
        case 5:
          _context.next = 7;
          return contentfulClient.getEntry('44YkXShSqazoZ5GdmawOay');
        case 7:
          entry = _context.sent;
          config = entry.fields.defaultRelevantFields;
        case 9:
          return _context.abrupt("return", config);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getEventTrackingConfig.apply(this, arguments);
}